// Table.jsx
import React from "react"
import { Link } from "react-router-dom"
import { Button } from "reactstrap"
import { FaSearch, FaCheck, FaTimes, FaClock } from "react-icons/fa"
import "./Table.css"
import { formatDate } from "helpers/formatDate"

export const ProcessTable = ({
  paginatedProcesses,
  handleStopMonitor,
  handleSendLead,
  getStatusClass,
  getStatusTexFromValue,
}) => (
  <div className="modern-table-container">
    <div className="table-responsive">
      <table className="modern-table">
        <thead>
          <tr>
            <th>Compartilhado</th>
            <th>Número CNJ</th>
            <th>Empresa</th>
            <th>Publicação</th>
            <th>Análise</th>
            <th>Monitoramento</th>
            <th>Status</th>
            <th>Última Movimentação</th>
            <th>Encerramento</th>
          </tr>
        </thead>
        <tbody>
          {paginatedProcesses.map(process => (
            <tr key={process?.Id}>
              <td className="text-center action-buttons">
                <Link
                  to="#"
                  onClick={() =>
                    window.open(`/qualificacao-detail/${process.Id}`, "_blank")
                  }
                  className="action-button view-button"
                  title="Analisar"
                >
                  <FaSearch />
                </Link>
                {process.Monitored ? (
                  <button
                    className="action-button stop-button"
                    onClick={() => handleStopMonitor(process)}
                    title="Parar Monitoramento"
                  >
                    <FaCheck />
                  </button>
                ) : (
                  <button
                    className="action-button send-button"
                    onClick={() => handleSendLead(process)}
                    title="Enviar Lead"
                  >
                    <FaTimes />
                  </button>
                )}
              </td>

              <td>{process?.NumeroCNJ}</td>
              <td>{process?.Lead?.ReuRazaoSocial}</td>
              <td>{formatDate(process?.Publicacoes[0]?.DataProcessamento)}</td>
              <td>
                {formatDate(process?.Lead?.DataCadastro || "Não Informado")}
              </td>
              <td>{formatDate(process?.Lead?.DataEnvio || "Não Informado")}</td>

              <td>
                <span
                  className={`status-badge ${getStatusClass(
                    getStatusTexFromValue(
                      Number(process?.Publicacoes[0]?.Status)
                    )
                  )}`}
                >
                  {getStatusTexFromValue(
                    Number(process?.Publicacoes[0]?.Status)
                  ) || "Sem Status"}
                </span>
              </td>

              <td>
                {process?.Andamentos.length > 0 &&
                process.Andamentos[0].dataAndamento ? (
                  <button
                    className="movement-button"
                    onClick={() =>
                      window.open(
                        `/linha-do-tempo/${process?.NumeroCNJ}`,
                        "_blank noreferrer"
                      )
                    }
                  >
                    <FaClock />
                    <span>
                      {formatDate(process.Andamentos[0].dataAndamento)}
                    </span>
                  </button>
                ) : (
                  <span className="no-data">-</span>
                )}
              </td>

              <td>
                {formatDate(process?.Lead?.DataEncerramento || "Não Informado")}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)
